export type Lang = "ru" | "en";

const dict = {
  ru: {
    home: "Главная",
    recent: "Недавние",
    favorites: "Избранное",
    spaces: "Пространства",
    spacesYouIn: "Пространства, в которых вы состоите",
    viewAllSpaces: "Просмотреть все пространства",
    templates: "Шаблоны",
    applyTemplate: "Применить шаблон",
    applyTemplateHint: "Добавит страницы шаблона в это пространство (существующие не удаляет).",
    applyTemplateConfirm: "Добавить страницы шаблона в пространство?",
    applyTemplateOk: "Шаблон применён",
    applyTemplateFail: "Не удалось применить шаблон",
    templatePages: "страниц",
    templateBuiltin: "встроенный",
    templatesEmpty: "Пока нет пользовательских шаблонов — есть встроенные ниже.",
    pickTemplate: "Выберите шаблон",
    settings: "Настройки",
    search: "Поиск документов…",
    create: "Создать",
    newSpace: "Новое пространство",
    newPage: "Новая страница",
    find: "Поиск",
    overview: "Обзор",
    overviewRecent: "Обновлено недавно",
    overviewMine: "Созданные мной",
    overviewFavEmpty: "В избранном этого пространства пока пусто.",
    overviewMineEmpty: "Вы ещё не создавали страниц здесь.",
    archPage: "Страница",
    archInside: "внутри",
    pages: "Страницы",
    recentOpens: "Последние",
    recentEmpty: "Пока нет открытых страниц.",
    sideMode: "Вид панели",
    sideWorkspace: "Воркспейс",
    sideRecent: "Последнее",
    pinned: "Закреплённые",
    pinPage: "Закрепить",
    unpinPage: "Открепить",
    pageColor: "Цвет",
    pageColorClear: "Без цвета",
    pageFilters: "Фильтры",
    sortLabel: "Сортировка",
    filterFavorites: "Только избранные",
    sortOrder: "Порядок",
    sortName: "По имени",
    sortUpdated: "По изменению",
    allSpaces: "Все пространства",
    continue: "Продолжить",
    goodMorning: "Доброе утро",
    whatNext: "Что будем делать?",
    continueWork: "Продолжить работу",
    lastChange: "Последнее изменение",
    openGo: "Открыть",
    activity: "Последние изменения",
    activityAll: "Показать всю активность",
    activitySearch: "Фильтр…",
    activityFilterAll: "Все",
    activityFilterCreated: "Созданные",
    activityFilterChanged: "Изменённые",
    activityFilterMine: "Мои",
    activityEmptyFilter: "Ничего не найдено по фильтру.",
    today: "Сегодня",
    yesterday: "Вчера",
    thisWeek: "На этой неделе",
    older: "Ранее",
    changedVerb: "Изменён",
    createdVerb: "Создан",
    versionN: "версия",
    homeStats: "Обзор",
    homeQuick: "Быстрые действия",
    homeDocs: "Документы",
    emptyContinue: "Пока нет недавних документов — открой пространство или спроси агента.",
    emptySpaceMascot: "Пространство пустое. Создай первую страницу — я рядом.",
    emptyActivity: "Пока тихо. Изменения появятся здесь.",
    agentOff: "Агент не подключён",
    agentFail: "Агент не ответил",
    agentSend: "Спросить",
    logout: "Выйти",
    myProfile: "Мой профиль",
    mySettings: "Мои настройки",
    theme: "Тема",
    themeDark: "Тёмная",
    themeLight: "Светлая",
    members: "Участники",
    spaceSettings: "Настройки пространства",
    spaceSecurity: "Безопасность",
    spaceIcon: "Иконка",
    spaceSlug: "Слаг",
    spaceSlugWarn: "Ссылки вида /s/{slug} перестанут работать",
    spaceDescription: "Описание",
    spaceExport: "Экспортировать",
    spaceDelete: "Удалить пространство",
    spaceDeleteHint: "Введите название, чтобы подтвердить удаление.",
    spaceRoleFull: "Полный доступ",
    spaceRoleEdit: "Может изменять",
    spaceRoleView: "Может просматривать",
    spaceFounder: "Основатель",
    spaceAdd: "Добавить",
    spaceFind: "Найти участника",
    spaceShareOff: "Отключить общий доступ",
    spaceShareOffHint: "Публичные ссылки перестанут открываться для всех",
    spacePrivateHint:
      "Все страницы по умолчанию закрыты: без входа их никто в интернете не увидит. Публичной становится только ссылка «Поделиться».",
    spaceShares: "Публичные ссылки",
    spaceSharesHint: "Активные ссылки «Поделиться»: кто создал, до когда действует, отзыв.",
    spaceSharesEmpty: "Активных публичных ссылок нет",
    spaceShareRevoke: "Отозвать",
    spaceShareExpires: "до",
    spaceShareBy: "создал",
    spaceSharesPending: "Нужна миграция БД (0340) — список ссылок пока недоступен",
    spaceViewerComments: "Разрешить зрителям комментировать",
    spaceViewerCommentsHint: "Появится вместе с комментариями.",
    soon: "Скоро",
    schemaPending: "Обновление базы в процессе, попробуйте позже",
    remove: "Удалить",
    slugExists: "Такой слаг уже занят",
    admin: "Админка",
    email: "Электронная почта",
    save: "Сохранить",
    sessions: "Сеансы",
    thisDevice: "Это устройство",
    logoutOthers: "Выйти на всех устройствах",
    logoutOthersHint: "Выйти из всех сеансов, кроме этого устройства",
    serviceKey: "Ключ входа",
    serviceKeyHint: "Показывается один раз. Сохраните его и вставьте в поиск этого сайта, чтобы войти только сюда.",
    issueKey: "Сгенерировать ключ",
    refreshKey: "Обновить ключ",
    online: "Сейчас",
    offline: "Не в сети",
    peopleEmpty: "Пока никого нет",
    peopleLoadFail: "Не удалось загрузить список",
    siteSection: "Сайт",
    regClosed: "Запрет регистрации",
    regClosedHint: "Новые аккаунты через OAuth не создаются без приглашения. Уже заведённые пользователи входят как обычно.",
    regClosedErr: "Регистрация закрыта. Нужна пригласительная ссылка.",
    invitePeople: "Пригласить людей",
    inviteCopied: "Ссылка-приглашение скопирована",
    inviteFailed: "Не удалось создать приглашение",
    name: "Имя",
    username: "Ник",
    avatar: "Аватар",
    role: "Роль",
    copy: "Копировать",
    keyWarn: "Прежний ключ перестанет работать.",
    keyRejected: "Ключ не подошёл",
    themeHint: "Выберите предпочитаемую цветовую схему.",
    language: "Язык",
    languageHint: "Выберите предпочитаемый язык интерфейса.",
    pageWidth: "Ширина на всю страницу",
    pageWidthHint: "Действует на все страницы.",
    editMode: "Режим редактирования страницы по умолчанию",
    editModeHint: "Выберите предпочитаемый режим редактирования страницы. Избегайте случайных изменений.",
    pinToolbar: "Закреплённая панель инструментов редактора",
    experimental: "экспериментально",
    pinToolbarHint: "Показывать панель форматирования над редактором для быстрого доступа к часто используемым действиям.",
    emailNotes: "Уведомления на email",
    notePage: "Обновления страницы",
    notePageHint: "Получайте уведомления, когда отслеживаемые вами страницы обновляются.",
    noteMention: "Упоминания на странице",
    noteMentionHint: "Получайте уведомления, когда кто-то упоминает вас на странице.",
    noteMentionComment: "Упоминания в комментариях",
    noteMentionCommentHint: "Получайте уведомления, когда кто-то упоминает вас в комментариях.",
    noteComment: "Новые комментарии",
    noteCommentHint: "Получайте уведомления о новых комментариях в цепочках, в которых вы участвуете.",
    noteResolved: "Разрешённые комментарии",
    noteResolvedHint: "Получайте уведомления, когда ваш комментарий разрешён.",
    version: "Версия",
    edit: "Редактировать",
    read: "Чтение",
    share: "Поделиться",
    shareHint: "Временная публичная ссылка только на эту страницу (остальное закрыто)",
    shareCustom: "Свой срок, минуты",
    shareCreate: "Создать ссылку",
    shareCopy: "Скопировать ссылку",
    shareGone: "Ссылка недействительна или срок истёк",
    shareLeft: "Осталось",
    minShort: "мин",
    comments: "Комментарии",
    commentsEmpty: "Нет открытых комментариев.",
    toc: "Оглавление",
    tocEmpty: "Добавьте заголовки (H1, H2, H3), чтобы создать оглавление.",
    copyLink: "Копировать ссылку",
    copyMd: "Копировать как Markdown",
    addFavorite: "Добавить в избранное",
    removeFavorite: "Убрать из избранного",
    watch: "Следить",
    unwatch: "Перестать следить",
    fullWidth: "Во всю ширину",
    history: "История страницы",
    historyEmpty: "Правок пока нет",
    addReview: "Добавить проверку",
    clearReview: "Снять проверку",
    move: "Переместить",
    moveRoot: "В корень пространства",
    copyTo: "Копировать",
    duplicate: "Дублировать",
    relocateParent: "Родительская страница",
    relocateFailed: "Не удалось выполнить операцию",
    cancel: "Отмена",
    exportMd: "Экспорт",
    exportMdFull: "Экспорт в Markdown",
    printPdf: "Печать PDF",
    trash: "Переместить в корзину",
    words: "Количество слов",
    chars: "Символы",
    created: "Создано",
    details: "Подробности",
    stats: "Статистика",
    byAuthor: "От",
    createdBy: "Создал",
    lastEditedBy: "Последний изменивший",
    lastUpdate: "Последнее обновление",
    backlinks: "Ссылки",
    linksIn: "Входящие ссылки",
    linksOut: "Исходящие ссылки",
    linksEmpty: "Ссылок в тексте нет",
    tags: "Метки",
    addTag: "Добавить метку",
    tagFind: "Найти или создать…",
    tagsEmpty: "Меток пока нет",
    tagsNoneMatch: "Нет совпадений — Enter создаст новую",
    copied: "Скопировано",
    hour: "час",
    hours3: "3 ч",
    hours6: "6 ч",
    hours12: "12 ч",
    day: "сутки",
    saved: "Сохранено",
    autosaved: "Автосохранено",
    conflict: "Страница изменена другим пользователем. Перезагрузите.",
    invite: "Участники",
    importDocmost: "Импорт Docmost",
    importZip: "Импорт ZIP",
    importFailed: "Не удалось импортировать экспорт Docmost",
    emptyChapter: "Здесь пока пусто. Начните первую главу.",
    heronId: "Heron UUID",
    closeTab: "Закрыть вкладку",
    moreTabs: "Ещё вкладки",
    collapseSidebar: "Свернуть панель",
    expandSidebar: "Развернуть панель",
    resizeSidebar: "Ширина панели",
    pickEmoji: "Эмодзи",
    clearEmoji: "Убрать",
    emojiSearch: "Поиск",
  },
  en: {
    home: "Home",
    recent: "Recent",
    favorites: "Favorites",
    spaces: "Spaces",
    spacesYouIn: "Spaces you belong to",
    viewAllSpaces: "View all spaces",
    templates: "Templates",
    applyTemplate: "Apply template",
    applyTemplateHint: "Adds the template pages into this space (does not delete existing ones).",
    applyTemplateConfirm: "Add template pages to this space?",
    applyTemplateOk: "Template applied",
    applyTemplateFail: "Could not apply template",
    templatePages: "pages",
    templateBuiltin: "built-in",
    templatesEmpty: "No custom templates yet — built-ins are listed below.",
    pickTemplate: "Choose a template",
    settings: "Settings",
    search: "Search documents…",
    create: "Create",
    newSpace: "New space",
    newPage: "New page",
    find: "Search",
    overview: "Overview",
    overviewRecent: "Recently updated",
    overviewMine: "Created by me",
    overviewFavEmpty: "No favorites in this space yet.",
    overviewMineEmpty: "You have not created pages here yet.",
    archPage: "Page",
    archInside: "inside",
    pages: "Pages",
    recentOpens: "Recent",
    recentEmpty: "No recently opened pages yet.",
    sideMode: "Sidebar view",
    sideWorkspace: "Workspace",
    sideRecent: "Recent",
    pinned: "Pinned",
    pinPage: "Pin",
    unpinPage: "Unpin",
    pageColor: "Color",
    pageColorClear: "No color",
    pageFilters: "Filters",
    sortLabel: "Sort",
    filterFavorites: "Favorites only",
    sortOrder: "Order",
    sortName: "By name",
    sortUpdated: "By update",
    allSpaces: "All spaces",
    continue: "Continue",
    goodMorning: "Good morning",
    whatNext: "What shall we do?",
    continueWork: "Continue work",
    lastChange: "Last change",
    openGo: "Open",
    activity: "Latest changes",
    activityAll: "Show all activity",
    activitySearch: "Filter…",
    activityFilterAll: "All",
    activityFilterCreated: "Created",
    activityFilterChanged: "Changed",
    activityFilterMine: "Mine",
    activityEmptyFilter: "Nothing matches this filter.",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This week",
    older: "Earlier",
    changedVerb: "Changed",
    createdVerb: "Created",
    versionN: "version",
    homeStats: "Overview",
    homeQuick: "Quick actions",
    homeDocs: "Documents",
    emptyContinue: "No recent documents yet — open a space or ask the agent.",
    emptySpaceMascot: "This space is empty. Create the first page — I’m here.",
    emptyActivity: "Quiet for now. Changes will show up here.",
    agentOff: "Agent is not connected",
    agentFail: "The agent did not answer",
    agentSend: "Ask",
    logout: "Log out",
    myProfile: "My profile",
    mySettings: "My settings",
    theme: "Theme",
    themeDark: "Dark",
    themeLight: "Light",
    members: "People",
    spaceSettings: "Space settings",
    spaceSecurity: "Security",
    spaceIcon: "Icon",
    spaceSlug: "Slug",
    spaceSlugWarn: "Links like /s/{slug} will stop working",
    spaceDescription: "Description",
    spaceExport: "Export",
    spaceDelete: "Delete space",
    spaceDeleteHint: "Type the name to confirm deletion.",
    spaceRoleFull: "Full access",
    spaceRoleEdit: "Can edit",
    spaceRoleView: "Can view",
    spaceFounder: "Founder",
    spaceAdd: "Add",
    spaceFind: "Find a person",
    spaceShareOff: "Disable public sharing",
    spaceShareOffHint: "Public links will stop opening for everyone",
    spacePrivateHint:
      "All pages are private by default — nothing is on the public internet until you use Share.",
    spaceShares: "Public links",
    spaceSharesHint: "Active Share links: who created them, expiry, and revoke.",
    spaceSharesEmpty: "No active public links",
    spaceShareRevoke: "Revoke",
    spaceShareExpires: "until",
    spaceShareBy: "by",
    spaceSharesPending: "DB migration 0340 required — share list unavailable",
    spaceViewerComments: "Allow viewers to comment",
    spaceViewerCommentsHint: "Arrives with comments.",
    soon: "Soon",
    schemaPending: "The database is still updating. Try again later",
    remove: "Remove",
    slugExists: "That slug is already used",
    admin: "Admin",
    email: "Email",
    save: "Save",
    sessions: "Sessions",
    thisDevice: "This device",
    logoutOthers: "Log out other devices",
    logoutOthersHint: "Sign out every session except this device",
    serviceKey: "Sign-in key",
    serviceKeyHint: "Shown once. Save it and paste it into this site's search to sign in here only.",
    issueKey: "Generate key",
    refreshKey: "Refresh key",
    online: "Online",
    offline: "Offline",
    peopleEmpty: "No people yet",
    peopleLoadFail: "Could not load people",
    siteSection: "Site",
    regClosed: "Block registration",
    regClosedHint: "New OAuth accounts need an invite. Existing users can still sign in.",
    regClosedErr: "Registration is closed. An invite link is required.",
    invitePeople: "Invite people",
    inviteCopied: "Invite link copied",
    inviteFailed: "Could not create invite",
    name: "Name",
    username: "Username",
    avatar: "Avatar",
    role: "Role",
    copy: "Copy",
    keyWarn: "The previous key stops working.",
    keyRejected: "Key was not accepted",
    themeHint: "Choose your preferred color scheme.",
    language: "Language",
    languageHint: "Choose your preferred interface language.",
    pageWidth: "Full page width",
    pageWidthHint: "Applies to every page.",
    editMode: "Default page editing mode",
    editModeHint: "Choose how a page opens. Avoid accidental edits.",
    pinToolbar: "Pinned editor toolbar",
    experimental: "experimental",
    pinToolbarHint: "Show the formatting bar above the editor for actions you use often.",
    emailNotes: "Email notifications",
    notePage: "Page updates",
    notePageHint: "Get notified when pages you watch are updated.",
    noteMention: "Mentions on a page",
    noteMentionHint: "Get notified when someone mentions you on a page.",
    noteMentionComment: "Mentions in comments",
    noteMentionCommentHint: "Get notified when someone mentions you in a comment.",
    noteComment: "New comments",
    noteCommentHint: "Get notified about new comments in threads you are in.",
    noteResolved: "Resolved comments",
    noteResolvedHint: "Get notified when your comment is resolved.",
    version: "Version",
    edit: "Edit",
    read: "Read",
    share: "Share",
    shareHint: "Temporary public link to this page only (everything else stays private)",
    shareCustom: "Custom duration, minutes",
    shareCreate: "Create link",
    shareCopy: "Copy link",
    shareGone: "Link is invalid or expired",
    shareLeft: "Time left",
    minShort: "min",
    comments: "Comments",
    commentsEmpty: "No open comments.",
    toc: "Contents",
    tocEmpty: "Add headings (H1, H2, H3) to build the contents.",
    copyLink: "Copy link",
    copyMd: "Copy as Markdown",
    addFavorite: "Add to favorites",
    removeFavorite: "Remove from favorites",
    watch: "Watch",
    unwatch: "Stop watching",
    fullWidth: "Full width",
    history: "Page history",
    historyEmpty: "No revisions yet",
    addReview: "Request review",
    clearReview: "Clear review",
    move: "Move",
    moveRoot: "To space root",
    copyTo: "Copy",
    duplicate: "Duplicate",
    relocateParent: "Parent page",
    relocateFailed: "Could not complete the action",
    cancel: "Cancel",
    exportMd: "Export",
    exportMdFull: "Export as Markdown",
    printPdf: "Print PDF",
    trash: "Move to trash",
    words: "Words",
    chars: "Characters",
    created: "Created",
    details: "Details",
    stats: "Statistics",
    byAuthor: "By",
    createdBy: "Created by",
    lastEditedBy: "Last edited by",
    lastUpdate: "Last update",
    backlinks: "Links",
    linksIn: "Incoming links",
    linksOut: "Outgoing links",
    linksEmpty: "No links in the text",
    tags: "Tags",
    addTag: "Add tag",
    tagFind: "Find or create…",
    tagsEmpty: "No tags yet",
    tagsNoneMatch: "No matches — Enter creates a new one",
    copied: "Copied",
    hour: "1 h",
    hours3: "3 h",
    hours6: "6 h",
    hours12: "12 h",
    day: "1 day",
    saved: "Saved",
    autosaved: "Autosaved",
    conflict: "Page was changed. Reload.",
    invite: "Members",
    importDocmost: "Import Docmost",
    importZip: "Import ZIP",
    importFailed: "Could not import Docmost export",
    emptyChapter: "Nothing here yet. Start the first chapter.",
    heronId: "Heron UUID",
    closeTab: "Close tab",
    moreTabs: "More tabs",
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
    resizeSidebar: "Resize sidebar",
    pickEmoji: "Emoji",
    clearEmoji: "Remove",
    emojiSearch: "Search",
  },
} as const;

export type MsgKey = keyof (typeof dict)["ru"];

export function t(lang: Lang, key: MsgKey): string {
  return dict[lang][key] || dict.en[key] || key;
}
